import Dialog from "@mui/material/Dialog";
import type { Ad } from "@models/Ad.model";
import type { AdCardRendererProps } from "./types";
import { AdCardHeader } from "./AdCardHeader";

type Props = {
    ad: Ad;
    open: boolean;
    onClose: () => void;
    Renderer: (props: AdCardRendererProps) => JSX.Element;
    resolved?: AdCardRendererProps["resolved"];
};

export default function AdCardFullModal({ ad, open, onClose, Renderer, resolved }: Props) {
    /*
        "View full" was capped at MUI's `sm`, 600px (MPN-1949).

        That is the whole width for a postcard, which draws its front and back side by side,
        so each side got about 280px and the client approving it could not read either. Rachel:
        "I can now see the front and back but the window is still teeny tiny -- I can't view it
        in full." On a client-facing approval screen, being unable to read the thing being
        approved is the failure, not a nicety.

        `lg` rather than a direct-mail special case: every type benefits from "view full"
        meaning it, and a renderer that wants less already constrains itself. The body scrolls,
        so a tall piece still fits the viewport.
    */
    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <div className="adcard adcard--full">
                <AdCardHeader ad={ad} menuActions={[{ label: "Close", onSelect: onClose }]} />
                <div className="adcard__body">
                    <Renderer ad={ad} mode="full" resolved={resolved} />
                </div>
            </div>
        </Dialog>
    );
}
